import { render, staticRenderFns } from "./BpCogsNumberDisplayer.vue?vue&type=template&id=30549fd2"
import script from "./BpCogsNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./BpCogsNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports